import { httpClient } from './httpClient';

export interface TenantRegistrationData {
  orgName: string;
  subdomain: string;
  admin: {
    name: string;
    email: string;
    password: string;
  };
}

export interface SubdomainCheckResponse {
  available: boolean;
  subdomain: string;
}

export interface TenantInfo {
  id: string;
  name: string;
  subdomain: string;
  createdAt?: string;
  totalAgents?: number;
}

export interface TenantRegistrationResponse {
  success: boolean;
  message?: string;
  tenant?: TenantInfo;
}

export interface TenantInfoResponse {
  success: boolean;
  tenant: TenantInfo;
}

export const tenantService = {
  /**
   * Register a new tenant organization
   * @param data Registration data including organization and admin details
   */
  async registerTenant(data: TenantRegistrationData): Promise<TenantRegistrationResponse> {
    try {
      return await httpClient.post<TenantRegistrationResponse>('/api/tenant/register', data);
    } catch (error) {
      console.error('Error registering tenant:', error);
      throw error;
    }
  },

  /**
   * Check if a subdomain is available
   * @param subdomain The subdomain to check
   */
  async checkSubdomainAvailability(subdomain: string): Promise<SubdomainCheckResponse> {
    return httpClient.get<SubdomainCheckResponse>(`/api/tenant/subdomain/${subdomain}`);
  },

  /**
   * Get tenant information by subdomain
   * @param subdomain The subdomain to get information for
   */
  async getTenantInfo(subdomain: string): Promise<TenantInfo> {
    const response = await httpClient.get<TenantInfoResponse>(`/api/tenant/info/${subdomain}`);
    return response.tenant;
  }
};
